<template>
  <div
    ref="baseDiv"
    class="fixed-left"
    :style="`max-width: ${size}; min-width: ${size};`"
    :class="{
      ['closed']: !sliderOpen && !initClosed,
      ['full_closed']: initClosed,
    }"
  >
    <div class="card-slot" :class="{ ['closed-slot']: !sliderOpen }">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewSliderRight',
  props: {
    isOpen: Boolean,
    size: {
      type: String,
      default: '47%',
    },
  },
  data() {
    return {
      initClosed: false,
      sliderOpen: false,
      clickOutsideEvent: null,
    }
  },
  watch: {
    isOpen: function (val) {
      if (this.initClosed) {
        this.initClosed = false
      }

      this.sliderOpen = !!val
    },
  },
  mounted() {
    this.initClosed = !this.isOpen
    this.sliderOpen = !!this.isOpen

    this.$refs.baseDiv.addEventListener('click', this.stopClick)
    document.addEventListener('click', this.clickOutSide)

    // document.addEventListener('keyup', this.pressClose);
  },
  destroyed() {
    document.removeEventListener('keyup', this.pressClose)
    document.removeEventListener('click', this.stopClick)
    document.removeEventListener('click', this.clickOutSide)
  },
  methods: {
    toogleTab() {
      if (this.initClosed) {
        this.initClosed = false
      }

      this.sliderOpen = !this.sliderOpen

      this.$emit('onChange', this.sliderOpen)
    },
    isOpened() {
      return this.sliderOpen
    },
    pressClose(e) {
      if (!this.sliderOpen) return

      if (e.key === 'Escape') {
        this.toogleTab(this.id)
      }
    },
    close() {
      this.sliderOpen = false
    },
    stopClick(e) {
      e.stopPropagation()
    },
    clickOutSide() {
      if (this.sliderOpen) {
        this.toogleTab()

        this.$emit('closed')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$animation_time: 200ms;
$tab_size: 47%;
$marginTop: 0%;

@keyframes fixed_left_new-animation {
  from {
    opacity: 0;
  }
}

@keyframes fixed_left_exclude-animation {
  from {
    opacity: 1;
  }
}

.fixed-left {
  z-index: 999;

  position: fixed;
  top: $marginTop;
  right: 0;

  max-width: $tab_size;
  min-width: $tab_size;

  min-height: 100% - $marginTop;
  max-height: 100% - $marginTop;

  background-color: white;
  animation: fixed_left_new-animation $animation_time;

  overflow: auto;
  overflow-x: hidden;
  overflow-y: scroll;

  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.closed {
  opacity: 0;
  z-index: -1;
  animation: fixed_left_exclude-animation $animation_time;
}

@keyframes card_new-animation {
  from {
    margin-left: 60%;
  }
}

@keyframes card_exclude-animation {
  from {
    margin-left: 0;
  }
  to {
    margin-left: 60%;
  }
}

.card-slot {
  margin-left: 0;
  animation: card_new-animation $animation_time;
  min-width: 100%;
  padding-left: 5%;
  padding-right: 2.5%;
}

.closed-slot {
  margin-left: 60%;
  animation: card_exclude-animation $animation_time;
}

.full_closed {
  z-index: -1;
  opacity: 0;
}
</style>
